import '../../css/study.css'
import Content from './Content';
import Nav from './Nav';
import Header from './Header';
import Footer from './Footer';
import { useQuery } from 'react-query';
import { useNavigate, useParams } from 'react-router-dom';
import API from '../../services/API/Study';
import Loader from '../Tools/Loader';
import { Alert } from '@mui/material';
import useFirstSection from './Hooks/useFirstSection';
import { txt } from '../../services/translation';
import useStore from './Hooks/useStore';
import { useEffect } from 'react';
import isScreenSmall from './isScreenSmall';

export default function Study(){

    const navigate = useNavigate();

    const {course, tab} = useParams();

    const {nav, toggleNav, setupNav, resetNav} = useStore();

    const firstSection = useFirstSection();

    useEffect(() => {

        setupNav()

        return () => resetNav()

    }, [setupNav, resetNav])

    const data = useQuery({

        queryKey: course,

        queryFn: () => API.getCourse(course).then(r => r.data),

        onSuccess: data => {

            if(!tab){
                navigate(`/study/${data.id}/${firstSection()?.id}`);
            }
        }
    })

    if( data.isLoading ) return <Loader />

    if( data.isError ) return <Alert severity='warning'>{txt('notEnrolledInCourse')}</Alert>


    return data.isSuccess &&
    
        <div className='study'>


            <Nav open={nav} onClose={toggleNav} />


            {(isScreenSmall() ? !nav : true) &&

                <main className='study-main'>

                    <Header nav={nav} onNavToggle={toggleNav}  />

                    <Content />

                    <Footer />

                </main> 
            }

        </div>
}